import React from "react";

export default function Home() {
    return (
        <div>
            <h1>HOME</h1>
        </div>
    );
}
